import React from "react";
import styled from "@emotion/styled";
import { ICommand, theme } from "Application";
import { Box, Label } from "Components";

export const CellContainer = styled(Box)`
    padding: 10px;
    position: relative;
    height: 100%;
    min-height: 92px;
    min-width: 110px;
    display: flex;
    align-items: center;
`;

export const LabelText = styled.div`
    text-decoration: underline;
    font: normal normal normal 12px/16px Open Sans;
    letter-spacing: -0.12px;
    color: #000000;
    cursor: pointer;
`;

const StyledStudentNameLabel = styled(LabelText)`
    margin-top: 4px;
`;

export const TimesLabel = styled(LabelText)`
    display: flex;
    text-decoration: none;
    gap: 5px;
`;

interface StudentNameLabelProps {
    command: ICommand;
    commandParam: any;
    children: React.ReactNode;
}

export const StudentNameLabel: React.FC<StudentNameLabelProps> = ({ command, commandParam, children }) => (
    <StyledStudentNameLabel onClick={() => command.execute(commandParam)}>{children}</StyledStudentNameLabel>
);

export const SessionStatusLabel = styled(Label)<{ $color?: string }>`
    margin-bottom: 4px;
    ${({ $color }) => $color && `color: ${$color};`}
`;

export const AttendanceLabel = styled(Label)<{ $color?: string }>`
    text-transform: none;
    min-height: 16px;
    ${({ $color }) => $color && `color: ${$color};`}
`;

export const IncidentLabel = styled(Label)`
    font-style: italic;
    text-transform: uppercase;
    color: #e6054e;
    min-height: 16px;
`;

export const CrossIcon = styled.span`
    pointer-events: none;
    position: relative;
    display: inline-block;
    width: 10px;
    height: 10px;

    &::before,
    &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 10px;
        height: 2px;
        background: ${theme.palette.field.text};
        border-radius: 1px;
    }

    &::before {
        transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
        transform: translate(-50%, -50%) rotate(-45deg);
    }
`;

export const PlusIcon = styled(CrossIcon)`
    &::before {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    &::after {
        transform: translate(-50%, -50%) rotate(90deg);
    }
`;

export const MinusIcon = styled.span`
    pointer-events: none;
    position: relative;
    display: inline-block;
    width: 10px;
    height: 10px;

    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 10px;
        height: 2px;
        background: ${theme.palette.field.text};
        border-radius: 1px;
        transform: translate(-50%, -50%);
    }
`;
